import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/appsumo/as-taco-white-bg.png")